<template>
  <div v-if="teamForm" class="py-8">
    <TeamPropertiesForm :form="teamForm" @on-save="saveTeam" @on-delete="confirmDelete"/>
  </div>
</template>

<script>
import TeamPropertiesForm from "@/Forms/Team/TeamPropertiesForm.vue";
import {mapStores} from "pinia";
import {useTeamsStore} from "@/stores/teams.js";

export default {
  name: "TeamPropertiesView",
  components: {TeamPropertiesForm},
  data() {
    return {
      teamForm: undefined,
    }
  },
  emits: [
    'on-save',
    'on-delete',
  ],
  computed: {
    ...mapStores(useTeamsStore)
  },
  methods: {
    async saveTeam() {
      try {
        const response = await this.teamForm.submit();
        this.$toast.add({
          severity: 'success',
          summary: this.$t('common.complete'),
          detail: this.$t('pages.admin.users.teams.team.properties.team_properties_view.team_saved'),
          life: 3000
        });
        this.$emit('on-save');
        this.$router.replace({params: {...this.$route.params, team: response.data.id}});
      } catch (error) {
        //
      }
    },
    confirmDelete() {
      this.$confirm.require({
        group: 'delete',
        message: this.$t('pages.admin.users.teams.team.properties.team_properties_view.are_you_sure_you_want_to_delete_this_team'),
        header: this.$t('pages.admin.users.teams.team.properties.team_properties_view.delete_team'),
        accept: () => {
          this.deleteTeam();
        },
        reject: () => {
          this.$toast.add({
            severity: 'info',
            summary: this.$t('common.cancelled'),
            detail: this.$t('pages.admin.users.teams.team.properties.team_properties_view.team_was_not_deleted'),
            life: 3000
          });
        }
      });
    },
    async deleteTeam() {
      try {
        if (this.$route.params.team !== 'NEW') {
          await this.teamsStore.deleteTeam(this.$route.params.team);
          this.$emit('on-delete');
        }
        this.$router.push({name: 'admin.users.teams', params: {...this.$route.params, team: undefined}});
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    '$route.params.team': {
      async handler(newValue, oldValue) {
        if (newValue) {
          if (this.$route.params.team === 'NEW') {
            this.teamForm = await this.teamsStore.createTeam();
          } else {
            this.teamForm = await this.teamsStore.editTeam(this.$route.params.team);
            this.teamForm.id = this.$route.params.team;
          }
        } else {
          this.teamForm = undefined;
        }
      },
      immediate: true,
    }
  },
}
</script>